<template>
  <div class="weekdays-selector">
      <h3>Kun specifikke dag/dage</h3>
      <app-toogler @changed="setSelectorActive" :propOn="false"></app-toogler>
    <div class="weekdays" v-if="isSelectorActive">
      <div class="weekday"
           v-for="(day, idx) in weekDays"
           :class="{'isSelected': isInList(day)}"
           @click="toggleDay(day, idx)">
        {{day.date | dddd}}
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import appToogler from '../common/AppToggle'

  export default {
    components: {appToogler},
    data () {
      return {
        isSelectorActive: false,
        selectedDays: []
      }
    },
    computed: {
      weekDays () {
        let weekDaysNumbers = [1, 2, 3, 4, 5, 6, 7]
        let weekDays = weekDaysNumbers.map(num => moment().isoWeekday(num))
        let days = weekDays.map(mom => {
          return {
            date: mom,
            isoWeekDay: moment(mom).isoWeekday()
          }
        })
        return days
      }
    },
    filters: {
      ddd (date) {
        return moment(date).format('dddd')
      }
    },
    methods: {
      setSelectorActive (Boolean) {
        this.isSelectorActive = Boolean
        console.log('true', Boolean)
      },
      isInList (day) {
        return this.selectedDays.indexOf(day.isoWeekDay) > -1
      },
      toggleDay (day, idx) {
        if (this.selectedDays.indexOf(day.isoWeekDay) < 0) {
          this.selectedDays.push(day.isoWeekDay)
        } else {
          this.selectedDays.splice(this.selectedDays.indexOf(day.isoWeekDay), 1)
        }
      }
    }
  }
</script>

<style scoped>

  @import '../../assets/css/variables.css';

  .weekdays-selector {
    margin: 15px 0;
  }

  .weekdays {
    display: flex;
    justify-content: space-between;
    height: 100%;
    width: 180px;
    min-width: 180px;
  }

  .weekdays > .weekday {
    display: flex;
    width: 100%;
    padding: 5px;
    justify-content: center;
    align-items: center;
    border: solid #acb6be;
    border-width: 1px 1px 1px 0;
    cursor: pointer;
    font-weight: bold;
    user-select: none;
  }

  .weekdays > .weekday:first-child {
    border-left: 1px solid #acb6be;
    border-radius: 4px 0 0 4px;
  }

  .weekdays > .weekday:last-child {
    border-radius: 0 4px 4px 0;
  }

  .weekdays > .weekday.isSelected {
    background-color: var(--blue);
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// SubsCreateDayPicker.vue?1c324856